var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "section",
    { staticClass: "column is-8-desktop px-0 px-sm-2 mx-auto" },
    [
      _c(
        "form",
        {
          staticClass:
            "form form-register d-flex flex-column justify-content-center",
          attrs: { method: "POST", action: "#" }
        },
        [
          _vm.errors
            ? _c(
                "div",
                { staticClass: "errors mb-4" },
                [
                  _vm._l(_vm.errors, function(item) {
                    return [
                      Array.isArray(item)
                        ? _vm._l(item, function(error) {
                            return _c("div", { staticClass: "error" }, [
                              _vm._v(_vm._s(error))
                            ])
                          })
                        : [
                            _c("div", { staticClass: "error" }, [
                              _vm._v(_vm._s(item))
                            ])
                          ]
                    ]
                  })
                ],
                2
              )
            : _vm._e(),
          _vm._v(" "),
          _c("div", { staticClass: "columns" }, [
            _c("div", { staticClass: "column is-half" }, [
              _c(
                "div",
                {
                  staticClass: "field mb-4",
                  class: { "has-error": _vm.$v.form.name.$error }
                },
                [
                  _c(
                    "label",
                    { staticClass: "label mb-1", attrs: { for: "name" } },
                    [_vm._v("Full Hazards Name*")]
                  ),
                  _vm._v(" "),
                  _c("div", { staticClass: "control" }, [
                    _c("input", {
                      directives: [
                        {
                          name: "model",
                          rawName: "v-model.trim",
                          value: _vm.$v.form.name.$model,
                          expression: "$v.form.name.$model",
                          modifiers: { trim: true }
                        }
                      ],
                      staticClass: "input",
                      attrs: { id: "name", name: "name", type: "text" },
                      domProps: { value: _vm.$v.form.name.$model },
                      on: {
                        input: function($event) {
                          if ($event.target.composing) {
                            return
                          }
                          _vm.$set(
                            _vm.$v.form.name,
                            "$model",
                            $event.target.value.trim()
                          )
                        },
                        blur: function($event) {
                          return _vm.$forceUpdate()
                        }
                      }
                    })
                  ]),
                  _vm._v(" "),
                  _vm.$v.$dirty && _vm.$v.form.name.$error
                    ? _c("div", { staticClass: "error" }, [
                        _vm._v(
                          "\n                        " +
                            _vm._s(_vm.getErrorMessage(_vm.$v.form.name)) +
                            "\n                    "
                        )
                      ])
                    : _vm._e()
                ]
              )
            ]),
            _vm._v(" "),
            _c("div", { staticClass: "column is-half" }, [
              _c(
                "div",
                {
                  staticClass: "field mb-4",
                  class: { "has-error": _vm.$v.form.hazard_type_id.$error }
                },
                [
                  _c(
                    "label",
                    { staticClass: "label mb-1", attrs: { for: "uxoType" } },
                    [_vm._v("UXO Type*")]
                  ),
                  _vm._v(" "),
                  _c("div", { staticClass: "control" }, [
                    _c(
                      "select",
                      {
                        directives: [
                          {
                            name: "model",
                            rawName: "v-model",
                            value: _vm.form.hazard_type_id,
                            expression: "form.hazard_type_id"
                          }
                        ],
                        staticClass: "select",
                        attrs: { id: "uxoType", name: "uxo_type" },
                        on: {
                          change: function($event) {
                            var $$selectedVal = Array.prototype.filter
                              .call($event.target.options, function(o) {
                                return o.selected
                              })
                              .map(function(o) {
                                var val = "_value" in o ? o._value : o.value
                                return val
                              })
                            _vm.$set(
                              _vm.form,
                              "hazard_type_id",
                              $event.target.multiple
                                ? $$selectedVal
                                : $$selectedVal[0]
                            )
                          }
                        }
                      },
                      [
                        _c("option", { attrs: { value: "" } }, [
                          _vm._v("Select a Type")
                        ]),
                        _vm._v(" "),
                        _vm._l(_vm.filteredTypes, function(type) {
                          return _c(
                            "option",
                            { domProps: { value: type.id } },
                            [
                              _vm._v(
                                _vm._s(type.name) +
                                  "\n                            "
                              )
                            ]
                          )
                        })
                      ],
                      2
                    )
                  ]),
                  _vm._v(" "),
                  _vm.$v.$dirty && _vm.$v.form.hazard_type_id.$error
                    ? _c("div", { staticClass: "error" }, [
                        _vm._v(
                          "\n                        " +
                            _vm._s(
                              _vm.getErrorMessage(_vm.$v.form.hazard_type_id)
                            ) +
                            "\n                    "
                        )
                      ])
                    : _vm._e()
                ]
              )
            ])
          ]),
          _vm._v(" "),
          _c("div", { staticClass: "columns" }, [
            _c("div", { staticClass: "column is-half" }, [
              _c(
                "div",
                {
                  staticClass: "field mb-4",
                  class: { "has-error": _vm.$v.form.category_id.$error }
                },
                [
                  _c(
                    "label",
                    { staticClass: "label mb-1", attrs: { for: "category" } },
                    [_vm._v("Category*")]
                  ),
                  _vm._v(" "),
                  _c("div", { staticClass: "control" }, [
                    _c(
                      "select",
                      {
                        directives: [
                          {
                            name: "model",
                            rawName: "v-model.trim",
                            value: _vm.$v.form.category_id.$model,
                            expression: "$v.form.category_id.$model",
                            modifiers: { trim: true }
                          }
                        ],
                        staticClass: "select",
                        attrs: { id: "category", name: "category" },
                        on: {
                          change: function($event) {
                            var $$selectedVal = Array.prototype.filter
                              .call($event.target.options, function(o) {
                                return o.selected
                              })
                              .map(function(o) {
                                var val = "_value" in o ? o._value : o.value
                                return val
                              })
                            _vm.$set(
                              _vm.$v.form.category_id,
                              "$model",
                              $event.target.multiple
                                ? $$selectedVal
                                : $$selectedVal[0]
                            )
                          }
                        }
                      },
                      [
                        _c("option", { attrs: { value: "", selected: "" } }, [
                          _vm._v("Select a Category")
                        ]),
                        _vm._v(" "),
                        _vm._l(_vm.categories, function(category) {
                          return _c(
                            "option",
                            { domProps: { value: category.id } },
                            [
                              _vm._v(
                                "\n                                " +
                                  _vm._s(category.name) +
                                  "\n                            "
                              )
                            ]
                          )
                        })
                      ],
                      2
                    )
                  ]),
                  _vm._v(" "),
                  _vm.$v.$dirty && _vm.$v.form.category_id.$error
                    ? _c("div", { staticClass: "error" }, [
                        _vm._v(
                          "\n                        " +
                            _vm._s(
                              _vm.getErrorMessage(_vm.$v.form.category_id)
                            ) +
                            "\n                    "
                        )
                      ])
                    : _vm._e()
                ]
              )
            ]),
            _vm._v(" "),
            _c("div", { staticClass: "column is-half" }, [
              _c(
                "div",
                {
                  staticClass: "field mb-4",
                  class: { "has-error": _vm.$v.form.country_id.$error }
                },
                [
                  _c(
                    "label",
                    {
                      staticClass: "label mb-1",
                      attrs: { for: "nationality" }
                    },
                    [_vm._v("Country of Origin*")]
                  ),
                  _vm._v(" "),
                  _c("div", { staticClass: "control" }, [
                    _c(
                      "select",
                      {
                        directives: [
                          {
                            name: "model",
                            rawName: "v-model.trim",
                            value: _vm.$v.form.country_id.$model,
                            expression: "$v.form.country_id.$model",
                            modifiers: { trim: true }
                          }
                        ],
                        staticClass: "select",
                        attrs: { id: "nationality", name: "nationality" },
                        on: {
                          change: function($event) {
                            var $$selectedVal = Array.prototype.filter
                              .call($event.target.options, function(o) {
                                return o.selected
                              })
                              .map(function(o) {
                                var val = "_value" in o ? o._value : o.value
                                return val
                              })
                            _vm.$set(
                              _vm.$v.form.country_id,
                              "$model",
                              $event.target.multiple
                                ? $$selectedVal
                                : $$selectedVal[0]
                            )
                          }
                        }
                      },
                      [
                        _c("option", { attrs: { value: "", selected: "" } }, [
                          _vm._v("Select a Country")
                        ]),
                        _vm._v(" "),
                        _vm._l(_vm.countries, function(country) {
                          return _c(
                            "option",
                            { domProps: { value: country.id } },
                            [
                              _vm._v(
                                "\n                                " +
                                  _vm._s(country.name) +
                                  "\n                            "
                              )
                            ]
                          )
                        })
                      ],
                      2
                    )
                  ]),
                  _vm._v(" "),
                  _vm.$v.$dirty && _vm.$v.form.country_id.$error
                    ? _c("div", { staticClass: "error" }, [
                        _vm._v(
                          "\n                        " +
                            _vm._s(
                              _vm.getErrorMessage(_vm.$v.form.country_id)
                            ) +
                            "\n                    "
                        )
                      ])
                    : _vm._e()
                ]
              )
            ])
          ]),
          _vm._v(" "),
          _c("div", { staticClass: "columns" }, [
            _c("div", { staticClass: "column is-full" }, [
              _vm._m(0),
              _vm._v(" "),
              _c("div", { staticClass: "field position-relative mb-4" }, [
                _c("div", { staticClass: "upload" }, [
                  _c("div", { staticClass: "control" }, [
                    _c(
                      "div",
                      {
                        staticClass:
                          "upload__select p1 t-dark-grey lh-reset bg-white px-1 px-sm-2 py-2"
                      },
                      [
                        _c(
                          "file-upload",
                          {
                            ref: "upload",
                            staticClass: "file-upload",
                            attrs: {
                              id: "fileUpload",
                              extensions: "gif,jpg,jpeg,png,webp,pdf",
                              accept:
                                "image/png,image/gif,image/jpeg,image/webp,application/pdf,text/csv,text/plain,application/msword,application/vnd.openxmlformats-officedocument.wordprocessingml.document,application/vnd.ms-excel,application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
                              multiple: true,
                              size: 1024 * 1024 * 10
                            },
                            on: {
                              "input-filter": _vm.inputFilter,
                              "input-file": _vm.inputFile
                            },
                            model: {
                              value: _vm.files,
                              callback: function($$v) {
                                _vm.files = $$v
                              },
                              expression: "files"
                            }
                          },
                          [
                            _vm._v(
                              "\n                                    Choose files\n                                "
                            )
                          ]
                        )
                      ],
                      1
                    )
                  ]),
                  _vm._v(" "),
                  _c("div", { staticClass: "control" }, [
                    _c(
                      "button",
                      {
                        staticClass: "btn btn-upload",
                        on: {
                          click: function($event) {
                            $event.preventDefault()
                            return _vm.$refs.upload.$children[0].$el.click()
                          }
                        }
                      },
                      [
                        _vm._v(
                          "\n                                Choose Files\n                            "
                        )
                      ]
                    )
                  ]),
                  _vm._v(" "),
                  _vm.files.length
                    ? _c("div", { staticClass: "upload__files mt-4" }, [
                        _c("div", { staticClass: "t-navy lh-lg mb-1" }, [
                          _vm._v("Files to upload")
                        ]),
                        _vm._v(" "),
                        _c(
                          "ul",
                          { staticClass: "files t-navy rows" },
                          [
                            _vm._l(_vm.files, function(file, index) {
                              return _c(
                                "li",
                                {
                                  key: file.id,
                                  staticClass:
                                    "file odd row px-1 px-sm-3 py-12px t-navy w-100"
                                },
                                [
                                  _c("div", { staticClass: "d-flex w-100" }, [
                                    _c(
                                      "div",
                                      {
                                        staticClass:
                                          "column p-0 file__name fs-18 py-12px"
                                      },
                                      [_vm._v(_vm._s(file.name))]
                                    ),
                                    _vm._v(" "),
                                    _c(
                                      "div",
                                      {
                                        staticClass:
                                          "column p-0 file__btn text-right"
                                      },
                                      [
                                        _c(
                                          "a",
                                          {
                                            directives: [
                                              {
                                                name: "scroll-to",
                                                rawName: "v-scroll-to",
                                                value: {
                                                  el: "#confirmDelete",
                                                  offset: -120
                                                },
                                                expression:
                                                  "{el: '#confirmDelete',offset: -120}"
                                              }
                                            ],
                                            staticClass:
                                              "btn btn-ghost btn-small w-100 p-1",
                                            on: {
                                              click: function($event) {
                                                $event.preventDefault()
                                                return _vm.confirmDelete(
                                                  file,
                                                  index
                                                )
                                              }
                                            }
                                          },
                                          [_vm._v("Delete")]
                                        )
                                      ]
                                    )
                                  ])
                                ]
                              )
                            }),
                            _vm._v(" "),
                            _vm.showConfirm
                              ? _c(
                                  "li",
                                  {
                                    staticClass:
                                      "file row px-1 px-sm-3 py-12px t-navy w-100"
                                  },
                                  [
                                    _c(
                                      "div",
                                      {
                                        staticClass:
                                          "d-flex w-100 align-items-center",
                                        attrs: { id: "confirmDelete" }
                                      },
                                      [
                                        _c(
                                          "div",
                                          {
                                            staticClass:
                                              "column is-8 font-weight-light p-0 py-12px"
                                          },
                                          [
                                            _vm._v(
                                              "\n                                            Are you sure you want to delete "
                                            ),
                                            _c("strong", [
                                              _vm._v(
                                                _vm._s(_vm.fileToDelete.name)
                                              )
                                            ]),
                                            _vm._v(
                                              "?\n                                        "
                                            )
                                          ]
                                        ),
                                        _vm._v(" "),
                                        _c(
                                          "div",
                                          {
                                            staticClass:
                                              "column p-0 buttons text-right"
                                          },
                                          [
                                            _c(
                                              "a",
                                              {
                                                staticClass:
                                                  "btn btn-ghost btn-small btn-small--navy w-100 p-1 mr-sm-2 mb-2 mb-sm-0",
                                                on: {
                                                  click: function($event) {
                                                    $event.preventDefault()
                                                    return _vm.keepFile()
                                                  }
                                                }
                                              },
                                              [_vm._v("Keep")]
                                            ),
                                            _vm._v(" "),
                                            _c(
                                              "a",
                                              {
                                                staticClass:
                                                  "btn btn-ghost btn-small w-100 p-1",
                                                on: {
                                                  click: function($event) {
                                                    $event.preventDefault()
                                                    return _vm.deleteFile()
                                                  }
                                                }
                                              },
                                              [_vm._v("Delete")]
                                            )
                                          ]
                                        )
                                      ]
                                    )
                                  ]
                                )
                              : _vm._e()
                          ],
                          2
                        )
                      ])
                    : _vm._e()
                ])
              ])
            ])
          ]),
          _vm._v(" "),
          _c("div", { staticClass: "columns" }, [
            _c("div", { staticClass: "column is-full" }, [
              _c(
                "div",
                {
                  staticClass: "field mb-4",
                  class: { "has-error": _vm.$v.form.description.$error }
                },
                [
                  _c(
                    "label",
                    {
                      staticClass: "label mb-1",
                      attrs: { for: "description" }
                    },
                    [_vm._v("Description*")]
                  ),
                  _vm._v(" "),
                  _c("div", { staticClass: "control" }, [
                    _c("textarea", {
                      directives: [
                        {
                          name: "model",
                          rawName: "v-model.trim",
                          value: _vm.$v.form.description.$model,
                          expression: "$v.form.description.$model",
                          modifiers: { trim: true }
                        }
                      ],
                      staticClass: "textarea",
                      attrs: { id: "description", name: "description" },
                      domProps: { value: _vm.$v.form.description.$model },
                      on: {
                        input: function($event) {
                          if ($event.target.composing) {
                            return
                          }
                          _vm.$set(
                            _vm.$v.form.description,
                            "$model",
                            $event.target.value.trim()
                          )
                        },
                        blur: function($event) {
                          return _vm.$forceUpdate()
                        }
                      }
                    })
                  ]),
                  _vm._v(" "),
                  _vm.$v.$dirty && _vm.$v.form.description.$error
                    ? _c("div", { staticClass: "error" }, [
                        _vm._v(
                          "\n                        " +
                            _vm._s(
                              _vm.getErrorMessage(_vm.$v.form.description)
                            ) +
                            "\n                    "
                        )
                      ])
                    : _vm._e()
                ]
              )
            ])
          ]),
          _vm._v(" "),
          _c("div", { staticClass: "columns" }, [
            _c("div", { staticClass: "column is-full" }, [
              _c("div", { staticClass: "field mb-4" }, [
                _c(
                  "label",
                  { staticClass: "label mb-1", attrs: { for: "operation" } },
                  [_vm._v("Additional Information")]
                ),
                _vm._v(" "),
                _c("div", { staticClass: "control" }, [
                  _c("textarea", {
                    directives: [
                      {
                        name: "model",
                        rawName: "v-model.trim",
                        value: _vm.$v.form.operation.$model,
                        expression: "$v.form.operation.$model",
                        modifiers: { trim: true }
                      }
                    ],
                    staticClass: "textarea",
                    attrs: { id: "operation", name: "operation" },
                    domProps: { value: _vm.$v.form.operation.$model },
                    on: {
                      input: function($event) {
                        if ($event.target.composing) {
                          return
                        }
                        _vm.$set(
                          _vm.$v.form.operation,
                          "$model",
                          $event.target.value.trim()
                        )
                      },
                      blur: function($event) {
                        return _vm.$forceUpdate()
                      }
                    }
                  })
                ])
              ])
            ])
          ]),
          _vm._v(" "),
          _c("div", { staticClass: "columns" }, [
            _c("div", { staticClass: "column is-full" }, [
              _c("div", { staticClass: "field mb-4" }, [
                _c(
                  "label",
                  { staticClass: "label mb-1", attrs: { for: "action" } },
                  [_vm._v("Possible EOD action")]
                ),
                _vm._v(" "),
                _c("div", { staticClass: "control" }, [
                  _c("textarea", {
                    directives: [
                      {
                        name: "model",
                        rawName: "v-model.trim",
                        value: _vm.$v.form.action.$model,
                        expression: "$v.form.action.$model",
                        modifiers: { trim: true }
                      }
                    ],
                    staticClass: "textarea",
                    attrs: { id: "action", name: "action" },
                    domProps: { value: _vm.$v.form.action.$model },
                    on: {
                      input: function($event) {
                        if ($event.target.composing) {
                          return
                        }
                        _vm.$set(
                          _vm.$v.form.action,
                          "$model",
                          $event.target.value.trim()
                        )
                      },
                      blur: function($event) {
                        return _vm.$forceUpdate()
                      }
                    }
                  })
                ])
              ])
            ])
          ]),
          _vm._v(" "),
          _c("div", { staticClass: "columns" }, [
            _c("div", { staticClass: "column is-full" }, [
              _c("div", { staticClass: "field mb-4" }, [
                _c(
                  "label",
                  { staticClass: "label mb-1", attrs: { for: "notes" } },
                  [_vm._v("Notes")]
                ),
                _vm._v(" "),
                _c("div", { staticClass: "control" }, [
                  _c("textarea", {
                    directives: [
                      {
                        name: "model",
                        rawName: "v-model.trim",
                        value: _vm.$v.form.notes.$model,
                        expression: "$v.form.notes.$model",
                        modifiers: { trim: true }
                      }
                    ],
                    staticClass: "textarea",
                    attrs: { id: "notes", name: "notes" },
                    domProps: { value: _vm.$v.form.notes.$model },
                    on: {
                      input: function($event) {
                        if ($event.target.composing) {
                          return
                        }
                        _vm.$set(
                          _vm.$v.form.notes,
                          "$model",
                          $event.target.value.trim()
                        )
                      },
                      blur: function($event) {
                        return _vm.$forceUpdate()
                      }
                    }
                  })
                ])
              ])
            ])
          ]),
          _vm._v(" "),
          _c(
            "div",
            { staticClass: "field mx-auto mb-3" },
            [
              !_vm.loading
                ? _c(
                    "button",
                    {
                      staticClass: "btn btn-form",
                      attrs: { type: "submit" },
                      on: {
                        click: function($event) {
                          $event.preventDefault()
                          return _vm.submit($event)
                        }
                      }
                    },
                    [
                      _vm._v(
                        "Add your\n                contribution\n            "
                      )
                    ]
                  )
                : _vm._e(),
              _vm._v(" "),
              _vm.loading
                ? _c("pulse-loader", {
                    attrs: { loading: true, color: "#E57722", size: "20px" }
                  })
                : _vm._e()
            ],
            1
          )
        ]
      ),
      _vm._v(" "),
      _vm.showUploader
        ? _c(
            "form",
            {
              staticClass:
                "form form-register d-flex flex-column justify-content-center",
              attrs: { method: "POST", action: "#" }
            },
            [
              _c("div", { staticClass: "columns" }, [
                _c("div", { staticClass: "column is-full" }, [
                  _vm._m(1),
                  _vm._v(" "),
                  _c(
                    "div",
                    { staticClass: "field position-relative mb-4" },
                    [_c("cat-uxo-uploader")],
                    1
                  )
                ])
              ])
            ]
          )
        : _vm._e(),
      _vm._v(" "),
      _vm.modalVisible
        ? _c(
            "cat-uxo-modal",
            {
              on: {
                close: function($event) {
                  return _vm.hideModal()
                }
              }
            },
            [
              _c(
                "h2",
                {
                  staticClass: "text-center t-orange",
                  attrs: { slot: "header" },
                  slot: "header"
                },
                [_vm._v("Thank you for contributing to CAT-UXO")]
              ),
              _vm._v(" "),
              _c(
                "div",
                {
                  staticClass:
                    "d-flex flex-column justify-content-center text-center w-75 mx-auto mb-5",
                  attrs: { slot: "body" },
                  slot: "body"
                },
                [
                  _c("p", [
                    _vm._v(
                      "You’ll be\n                able to view your contribution by clicking the button below. You can keep track of your\n                contributions by visiting "
                    ),
                    _c(
                      "a",
                      {
                        staticClass: "btn-link font-weight-normal",
                        attrs: { href: "/settings/profile" }
                      },
                      [_vm._v("your\n                    profile.")]
                    )
                  ])
                ]
              ),
              _vm._v(" "),
              _c(
                "div",
                {
                  staticClass: "d-flex justify-content-center",
                  attrs: { slot: "footer" },
                  slot: "footer"
                },
                [
                  _vm.hazard
                    ? _c(
                        "a",
                        {
                          staticClass: "btn btn-form mx-auto",
                          attrs: { href: _vm.hazard.url }
                        },
                        [_vm._v("View your contribution")]
                      )
                    : _vm._e()
                ]
              )
            ]
          )
        : _vm._e()
    ],
    1
  )
}
var staticRenderFns = [
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "field" }, [
      _c("label", { staticClass: "label mb-1" }, [_vm._v("Upload files")])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "field" }, [
      _c("label", { staticClass: "label mb-1" }, [_vm._v("Upload a file")])
    ])
  }
]
render._withStripped = true
module.exports = { render: render, staticRenderFns: staticRenderFns }
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-0571cc38", module.exports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-0571cc38","hasScoped":true,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./resources/js/components/forms/Contribute.vue
// module id = ./node_modules/vue-loader/lib/template-compiler/index.js?{"id":"data-v-0571cc38","hasScoped":true,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./resources/js/components/forms/Contribute.vue
// module chunks = 0 1